// extracted by mini-css-extract-plugin
module.exports = {"page":"ConsentsPage_page__qL6tl","title":"ConsentsPage_title__1401t"};